import React from 'react'
import classes from './ProductImageUploadPopUp.module.css'

export default function ProductImageUploadPopUp(props) {
    const { activePopUp, setActivePopUp } = props

    // const img_name = props.currentImage ? `${apiV1}/images/logo/${props.currentImage}` : ''

    // const [clicked, setClicked] = useState(false)

    if (activePopUp) {
        document.body.classList.add(classes.activeModel)
    } else {
        document.body.classList.remove(classes.activeModel)
    }

    return (
        <div className={classes.wrapper}>
            <div>
                <p>Please upload your product image!</p>
            </div>
            <div>
                <button
                    onClick={() => {
                        setActivePopUp(false)
                    }}>
                    OK
                </button>
            </div>{' '}
            {/* <button
                    onClick={() => {
                        setActivePopUp(false)
                        navigate('/login')
                    }}>
                    Okay
                </button> */}
        </div>
    )
}
